// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "0e54dca3",
    "hash": "0e54dca3",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "0e54dca3",
    "semverString": null,
    "version": "2026.4.0.7"
};
/* tslint:enable */
